import { render, staticRenderFns } from "./DeactiveOpportunity.vue?vue&type=template&id=6a48bacc&"
import script from "./DeactiveOpportunity.vue?vue&type=script&lang=js&"
export * from "./DeactiveOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./DeactiveOpportunity.vue?vue&type=style&index=0&id=6a48bacc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports